// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sucessStoriesScroll {
  height: 45vh;
  padding: 4vh;
}
.sucessStoriesScroll img {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.sucessStoriesScroll_div {
  position: relative;
  width: 100%;
  min-height: 55vh;
  min-height: 11rem;
  max-width: 20rem;
  padding: 1%;
  display: flex;
  justify-content: space-between;
}
.sucessStoriesScroll_text {
  color: var(--white, #fff);
  margin-top: 1vw;
  font-family: Roboto;
  font-size: 1vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3vw;
}

.sucessStoriesScroll_scroll {
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 2vh;
}

.sucessStoriesScroll_scrollleft {
  font-size: 5vh;
  color: #fff;
}

.sucessStoriesScroll_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(37, 60, 119, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 2rem;
  transition: opacity 0.25s;
  opacity: 0;
  border-radius: 20px;
}
.sucessStoriesScroll_overlay:hover {
  opacity: 1;
  cursor: pointer;
}

@media only screen and (max-width: 992px) {
  .sucessStoriesScroll {
    height: 100%;
  }
  .sucessStoriesScroll_text {
    font-size: 1.5vw;
    line-height: 2.5vw;
    margin-top: 0vw;
  }
  .sucessStoriesScroll_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(37, 60, 119, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 2rem;
    transition: opacity 0.25s;
    opacity: 0;
    border-radius: 20px;
  }
  .sucessStoriesScroll_overlay:hover {
    opacity: 1;
    cursor: pointer;
  }
  .sucessStoriesScroll_scrollleft {
    font-size: 2vh;
  }
}
@media only screen and (max-width: 600px) {
  .sucessStoriesScroll {
    height: 100%;
  }
  .sucessStoriesScroll_text {
    font-size: 4vw;
    line-height: 4.5vw;
    margin-top: 2vw;
  }
  .sucessStoriesScroll_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 75%;
    background: rgba(37, 60, 119, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 2rem;
    transition: opacity 0.25s;
    opacity: 0;
    border-radius: 20px;
  }
  .sucessStoriesScroll_overlay:hover {
    opacity: 1;
    cursor: pointer;
  }
  .sucessStoriesScroll .sucessStoriesScroll_scrollleft {
    font-size: 2.5vh;
  }
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
  .sucessStoriesScroll {
    height: 100%;
  }
  .sucessStoriesScroll_text {
    font-size: 2vw;
    line-height: 2.5vw;
    margin-top: 0vw;
  }
  .sucessStoriesScroll_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 75%;
    background: rgba(37, 60, 119, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 2rem;
    transition: opacity 0.25s;
    opacity: 0;
    border-radius: 20px;
  }
  .sucessStoriesScroll_overlay:hover {
    opacity: 1;
    cursor: pointer;
  }
  .sucessStoriesScroll_scrollleft {
    font-size: 3vh;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1025px) {
  .sucessStoriesScroll {
    height: 100%;
  }
  .sucessStoriesScroll_text {
    font-size: 1.3vw;
    line-height: 2vw;
    margin-top: -4vw;
  }
  .sucessStoriesScroll_scrollleft {
    font-size: 3vh;
  }
  .sucessStoriesScroll_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 65%;
    background: rgba(37, 60, 119, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 2rem;
    transition: opacity 0.25s;
    opacity: 0;
    border-radius: 20px;
  }
  .sucessStoriesScroll_overlay:hover {
    opacity: 1;
    cursor: pointer;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1300px) {
  .sucessStoriesScroll_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 85%;
    background: rgba(37, 60, 119, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 2rem;
    transition: opacity 0.25s;
    opacity: 0;
    border-radius: 20px;
  }
  .sucessStoriesScroll_overlay:hover {
    opacity: 1;
    cursor: pointer;
  }
}
@media screen and (min-width: 2559px) {
  .sucessStoriesScroll {
    height: 100%;
  }
  .sucessStoriesScroll_div {
    position: relative;
    width: 100%;
    min-height: 55vh;
    min-height: 11rem;
    max-width: 35rem;
    padding: 1%;
    display: flex;
    justify-content: space-between;
  }
  .sucessStoriesScroll_text {
    text-align: center;
    font-size: 2rem;
  }
  .sucessStoriesScroll_img {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SucessStoriesScroll/sucessStoriesScroll.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAEJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AACJ;AAEE;EACE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;AADF;;AAKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;AAFJ;AAKE;EACE,UAAA;EACA,eAAA;AAHJ;;AAOA;EACE;IACE,YAAA;EAJF;EAME;IACE,gBAAA;IACA,kBAAA;IACA,eAAA;EAJJ;EAME;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,yBAAA;IACA,UAAA;IACA,mBAAA;EAJJ;EAOE;IACE,UAAA;IACA,eAAA;EALJ;EAQA;IACE,cAAA;EANF;AACF;AAQA;EACE;IACE,YAAA;EANF;EAQE;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EANJ;EAQE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,yBAAA;IACA,UAAA;IACA,mBAAA;EANJ;EASE;IACE,UAAA;IACA,eAAA;EAPJ;EASE;IACE,gBAAA;EAPJ;AACF;AAWA;EACE;IACE,YAAA;EATF;EAWE;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EATJ;EAWE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,yBAAA;IACA,UAAA;IACA,mBAAA;EATJ;EAYE;IACE,UAAA;IACA,eAAA;EAVJ;EAaA;IACE,cAAA;EAXF;AACF;AAaA;EACE;IACE,YAAA;EAXF;EAaE;IACE,gBAAA;IACA,gBAAA;IACA,gBAAA;EAXJ;EAcA;IACE,cAAA;EAZF;EAeE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,yBAAA;IACA,UAAA;IACA,mBAAA;EAbJ;EAgBE;IACE,UAAA;IACA,eAAA;EAdJ;AACF;AAiBA;EAEI;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,kCAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,yBAAA;IACA,UAAA;IACA,mBAAA;EAhBJ;EAmBE;IACE,UAAA;IACA,eAAA;EAjBJ;AACF;AAoBA;EACE;IACE,YAAA;EAlBF;EAmBE;IACE,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,aAAA;IACA,8BAAA;EAjBJ;EAoBE;IACE,kBAAA;IACA,eAAA;EAlBJ;EAqBE;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,eAAA;EAnBJ;AACF","sourcesContent":[".sucessStoriesScroll {\n  height: 45vh;\n  padding: 4vh;\n  img {\n    width: 100%;\n    height: 100%;\n    border-radius: 20px;\n  }\n\n  &_div {\n    position: relative;\n    width: 100%;\n    min-height: 55vh;\n    min-height: 11rem;\n    max-width: 20rem;\n    padding: 1%;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &_text {\n    color: var(--white, #fff);\n    margin-top: 1vw;\n    font-family: Roboto;\n    font-size: 1vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.3vw;\n  }\n}\n\n.sucessStoriesScroll_scroll {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  margin-top: 2vh;\n}\n\n.sucessStoriesScroll_scrollleft {\n  font-size: 5vh;\n  color: #fff;\n}\n\n.sucessStoriesScroll {\n  &_overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(37, 60, 119, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #ffffff;\n    font-size: 2rem;\n    transition: opacity 0.25s;\n    opacity: 0;\n    border-radius: 20px;\n  }\n\n  &_overlay:hover {\n    opacity: 1;\n    cursor: pointer;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .sucessStoriesScroll {\n    height: 100%;\n\n    &_text {\n      font-size: 1.5vw;\n      line-height: 2.5vw;\n      margin-top: 0vw;\n    }\n    &_overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: rgba(37, 60, 119, 0.5);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #ffffff;\n      font-size: 2rem;\n      transition: opacity 0.25s;\n      opacity: 0;\n      border-radius: 20px;\n    }\n\n    &_overlay:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n  .sucessStoriesScroll_scrollleft {\n    font-size: 2vh;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .sucessStoriesScroll {\n    height: 100%;\n\n    &_text {\n      font-size: 4vw;\n      line-height: 4.5vw;\n      margin-top: 2vw;\n    }\n    &_overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 75%;\n      background: rgba(37, 60, 119, 0.5);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #ffffff;\n      font-size: 2rem;\n      transition: opacity 0.25s;\n      opacity: 0;\n      border-radius: 20px;\n    }\n\n    &_overlay:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n    .sucessStoriesScroll_scrollleft {\n      font-size: 2.5vh;\n    }\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 800px) {\n  .sucessStoriesScroll {\n    height: 100%;\n\n    &_text {\n      font-size: 2vw;\n      line-height: 2.5vw;\n      margin-top: 0vw;\n    }\n    &_overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 75%;\n      background: rgba(37, 60, 119, 0.5);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #ffffff;\n      font-size: 2rem;\n      transition: opacity 0.25s;\n      opacity: 0;\n      border-radius: 20px;\n    }\n\n    &_overlay:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n  .sucessStoriesScroll_scrollleft {\n    font-size: 3vh;\n  }\n}\n@media only screen and (min-width: 992px) and (max-width: 1025px) {\n  .sucessStoriesScroll {\n    height: 100%;\n\n    &_text {\n      font-size: 1.3vw;\n      line-height: 2vw;\n      margin-top: -4vw;\n    }\n  }\n  .sucessStoriesScroll_scrollleft {\n    font-size: 3vh;\n  }\n  .sucessStoriesScroll {\n    &_overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 65%;\n      background: rgba(37, 60, 119, 0.5);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #ffffff;\n      font-size: 2rem;\n      transition: opacity 0.25s;\n      opacity: 0;\n      border-radius: 20px;\n    }\n\n    &_overlay:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n}\n@media only screen and (min-width: 1025px) and (max-width: 1300px) {\n  .sucessStoriesScroll {\n    &_overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 85%;\n      background: rgba(37, 60, 119, 0.5);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: #ffffff;\n      font-size: 2rem;\n      transition: opacity 0.25s;\n      opacity: 0;\n      border-radius: 20px;\n    }\n\n    &_overlay:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n}\n@media screen and (min-width: 2559px) {\n  .sucessStoriesScroll {\n    height: 100%;\n    &_div {\n      position: relative;\n      width: 100%;\n      min-height: 55vh;\n      min-height: 11rem;\n      max-width: 35rem;\n      padding: 1%;\n      display: flex;\n      justify-content: space-between;\n    }\n\n    &_text {\n      text-align: center;\n      font-size: 2rem;\n    }\n\n    &_img {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
